import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import FeatureFlagged from '../../authorization/feature-flagged';
import {
    REPAIR_WARRANTY_PREFERENCES,
    SHIPPING_PREFERENCES,
    ORDER_NOTIFICATION_PREFERENCES,
    INVOICE_DELIVERY_PREFERENCES,
} from '../../../models/constants';

const PreferencesHome = () => {
    return (
        <>
            <div>
                <h1>
                    <FormattedMessage
                        id="Preferences"
                        defaultMessage="Preferences"
                    />
                </h1>
            </div>
            <div className="routes">
                <ul>
                    <FeatureFlagged features={[REPAIR_WARRANTY_PREFERENCES]}>
                        <li>
                            <h2>
                                <Link to="/my-account/preferences/repair-warranty">
                                    <FormattedMessage id="Repair_Warranty_Preferences" />
                                </Link>
                            </h2>
                        </li>
                    </FeatureFlagged>
                    <FeatureFlagged features={[SHIPPING_PREFERENCES]}>
                        <li>
                            <h2>
                                <Link to="/my-account/preferences/shipping">
                                    <FormattedMessage id="Shipping_Preferences" />
                                </Link>
                            </h2>
                        </li>
                    </FeatureFlagged>
                    <FeatureFlagged features={[ORDER_NOTIFICATION_PREFERENCES]}>
                        <li>
                            <h2>
                                <Link to="/my-account/preferences/order-notification">
                                    <FormattedMessage id="Order_Notification_Preferences" />
                                </Link>
                            </h2>
                        </li>
                    </FeatureFlagged>
                    <FeatureFlagged features={[INVOICE_DELIVERY_PREFERENCES]}>
                        <li style={{ display: 'none' }}>
                            <h2>
                                <Link to="./">
                                    <FormattedMessage id="Invoice_Delivery_Preferences" />
                                </Link>
                            </h2>
                        </li>
                    </FeatureFlagged>
                </ul>
            </div>
        </>
    );
};

export default PreferencesHome;
